import * as React from "react";
import { Card } from "antd";
import { CardTitle } from "../../../components/antd/card/CardTitle";
import { CardContent } from "../../../components/antd/card/CardContent";
import { request } from "../../../services/cpln";
import { formSetValue, useCpFormValue } from "../../gvc/testNewForm/utils";
import { CpSelect } from "../../gvc/testNewForm/CpSelect";
import { CpFormItem } from "../../gvc/testNewForm/CpFormItem";
import { CpInputDescription } from "../../gvc/testNewForm/CpInputDescription";
import { CpLabel } from "../../gvc/testNewForm/CpLabel";
import { CpErrorWarning } from "../../gvc/testNewForm/CpErrorWarning";
import { CpInput } from "../../gvc/testNewForm/CpInput";
import { useCpFormContext } from "../../../components/form/useCpFormContext";
import { CpErrorWarningArrayIcon } from "../../gvc/testNewForm/CpErrorWarningArrayIcon";
import { CpLabelTooltip } from "../../gvc/testNewForm/CpLabelTooltip";
import { CpTooltip } from "../../gvc/testNewForm/CpTooltip";
import { CpRadioCardGroup } from "../../gvc/testNewForm/CpRadioCardGroup";
import { toSelectOptions } from "../../../services/defaults";
import { IS_DEPLOYMENT_ENV_PROD } from "../../../envVariables";

interface Props {}
export const General: React.FC<Props> = ({}) => {
  const { id } = useCpFormContext();

  const isCreate = useCpFormValue(`meta.isCreate`);
  const name = useCpFormValue("name");

  const providerOptions = React.useMemo(() => {
    if (IS_DEPLOYMENT_ENV_PROD) {
      return [
        { label: "AWS", value: "aws", children: <></> },
        { label: "Azure", value: "azure", children: <></> },
        { label: "Digital Ocean", value: "digitalocean", children: <></> },
        { label: "GCP", value: "gcp", children: <></> },
        { label: "Generic", value: "generic", children: <></> },
        { label: "Hetzner", value: "hetzner", children: <></> },
        { label: "Lambdalabs", value: "lambdalabs", children: <></> },
        { label: "Linode", value: "linode", children: <></> },
        { label: "Oblivus", value: "oblivus", children: <></> },
        { label: "Paperspace", value: "paperspace", children: <></> },
        { label: "Triton", value: "triton", children: <></> },
      ];
    }
    return [
      { label: "AWS", value: "aws", children: <></> },
      { label: "Azure", value: "azure", children: <></> },
      { label: "Digital Ocean", value: "digitalocean", children: <></> },
      { label: "Ephemeral", value: "ephemeral", children: <></> },
      { label: "GCP", value: "gcp", children: <></> },
      { label: "Generic", value: "generic", children: <></> },
      { label: "Hetzner", value: "hetzner", children: <></> },
      { label: "Lambdalabs", value: "lambdalabs", children: <></> },
      { label: "Linode", value: "linode", children: <></> },
      { label: "Oblivus", value: "oblivus", children: <></> },
      { label: "Paperspace", value: "paperspace", children: <></> },
      { label: "Triton", value: "triton", children: <></> },
    ];
  }, []);

  const [versionOptions, setVersionOptions] = React.useState<any[]>(
    toSelectOptions([
      "1.26.0",
      "1.26.4",
      "1.27.3",
      "1.28.2",
      "1.28.4",
      "1.29.7",
      "1.30.3",
      "1.31.5",
      "1.31.13",
      "1.32.1",
      "1.32.9",
      "1.33.5",
      "1.34.2",
      "1.35.3",
    ]),
  );

  React.useEffect(() => {
    fetchSchemaData();
  }, []);

  async function fetchSchemaData() {
    // Versions
    try {
      const { data: schemaRes } = await request({ url: "/catalog/schema/mk8s" });
      const versions: string[] = schemaRes.keys.spec.keys.version.allow;
      const _versionOptions = versions.map((v) => ({ label: v, value: v })).reverse();
      setVersionOptions(_versionOptions);
      if (isCreate) {
        formSetValue(id, `specVersion`, versions[versions.length - 1] as any);
      }
    } catch (e) {
      console.error("Failed to get versions from mk8s catalog schema");
    }
  }

  return (
    <div className="cpln-form-section cpln-ant-card-container">
      <Card>
        <CardTitle>
          General
          <CpErrorWarningArrayIcon names={["name", "description"]} />
        </CardTitle>
        <CardContent>
          {isCreate ? (
            <CpFormItem>
              <CpLabelTooltip>
                <CpLabel name={`name`}>Name</CpLabel>
                <CpTooltip tooltipProps={{ title: "Cannot be changed after creation (ok, my-item, item1)" }} />
              </CpLabelTooltip>
              <CpInput name={`name`} style={{ maxWidth: 600 }} />
              <CpErrorWarning name={`name`} />
            </CpFormItem>
          ) : (
            <div className="mb-8">
              <div className="cursor-default">Name</div>
              <div className="color-default">{name}</div>
            </div>
          )}
          <CpInputDescription namePath="name" descriptionPath="description" />
          <CpFormItem>
            <CpLabel name={`specVersion`}>Kubernetes Version</CpLabel>
            <CpSelect name={`specVersion`} style={{ width: 600 }} options={versionOptions} />
            <CpErrorWarning name={`specVersion`} />
          </CpFormItem>
          <CpFormItem>
            <CpLabel name={`provider`}>Provider</CpLabel>
            <div style={{ maxWidth: 600 }}>
              <CpRadioCardGroup name={`provider`} grid gridCols={3} options={providerOptions} />
            </div>
            <CpErrorWarning name={`provider`} />
          </CpFormItem>
        </CardContent>
      </Card>
    </div>
  );
};
